/* template */
<template><es-popup :value="showAlert" mpxModelEvent="input" @mpxModel='__model("showAlert", $event, ["value"], undefined)' position="bottom" closeable @close="closePopup"><div class="tips-main"><div class="tips-container"><div class="header"><div class="tipsTitle">{{ info && info.window_title }}</div></div><mpx-scroll-view :scroll-y="(true)" class="sroll-content-height"><div class="content"><div v-for="(item, index) in (info ? info.content_list : [])" :key="item.index" class="content-item"><div class="item-title" v-if="(item.title)"><es-icon name="exclamation-circle" size="18" class="item-icon"/><div>{{ item.title }}</div></div><div class="item-content">{{ item.content }}</div></div></div></mpx-scroll-view><div class="btn-bottom"><es-button block type="info" @click="closePopup" class="content-button" :custom-class='["button"].join(" ")'>我知道了</es-button></div></div></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m9be6912a"}'>
  .custom-class
    top 120px
  .tips-main
    height 300px
  .header
    border-radius 16px 16px 0 0
    width 100%
    height 60px
    background #ffffff
    display flex
    align-items center
    justify-content center
    .tipsTitle
      text-align center
      width 217px
      line-height 25px
      font-family PingFangSC-Medium
      font-size 18px
      color #333333
  .tips-container
    background #FFFFFF
    border-radius 16px 16px 0 0
    padding-bottom 84px
  .close
    position absolute
    top 18px
    right 13px
    width 27px
    height 27px
    line-height 27px
    text-align center
  .sroll-content-height
    height 156px
  .content
    padding 0 20px
    box-sizing border-box
    border-radius 16px 16px 0 0
  .content-item
    font-family PingFangSC-Regular
    font-size 13px
    color #666666
    letter-spacing 0
    background #ffffff
    padding-bottom 15px
  .item-title
    display flex
    font-family PingFangSC-Medium
    font-size 16px
    color #1473ff
    letter-spacing 0
    line-height 18px
    align-items center
    .item-icon
      margin-right 5px
  .item-little-title
    font-family PingFangSC-Medium
    font-size 14px
    color #333333
    letter-spacing 0
    text-align justify
    line-height 14px
    margin-top 12px
    margin-bottom 8px
  .item-content
    font-size 14px
    color #333333
    letter-spacing 0
    text-align justify
    line-height 24px
    white-space pre-wrap
  .item-time
    font-size 12px
    color #333333
    letter-spacing 0
    text-align justify
    line-height 24px
  .content-item .blue
    color #1473FF
    margin-bottom 11px
  .legal
    background #FFF4EE
    border-radius 8px
    padding 10px 12px
    font-size 12px
    color #FF7D41
    letter-spacing 0
    text-align justify
    line-height 17px
    margin-bottom 32px
  .btn-bottom
    position fixed
    bottom 0
    background #ffffff
    width -webkit-fill-available
    padding 20px
  .content-button
    border-radius 8px
    font-size 16px
    font-weight 500
  .button
    border-radius 8px !important
    font-size 16px
    font-weight 500
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m9be6912a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./noticePopup.mpx.js?isComponent&outputPath=components%2FnoticePopup9be6912a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./noticePopup.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2FnoticePopup9be6912a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m9be6912a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/noticePopup9be6912a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-button':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-popup':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
